<template>
  <div class="convention-hall page">
    <div class="nav-bar van-nav-bar van-hairline--bottom">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__title van-ellipsis">{{ $t("choose.title") }}</div>
      </div>
    </div>
    <div class="convention-item">
      <van-tabs v-model="active" animated swipeable @change="OnChange">
        <van-tab v-for="(v,key) in addlist" :key="key" :title="v" :name="key">

          <div class="van-tabs__track"
               style="transform: translate3d(0%, 0px, 0px); transition-duration: 0.3s;">
            <div role="tabpanel" class="van-tab__pane-wrapper">
              <div class="van-tab__pane">
                <div class="card">{{ $t("choose.rule") }}</div>
                <div class="beautyFirstContain beauty-router-view" v-if="active == 0">
                  <div v-for="(item,k) in datalist" :key="k" @click="profile(item.id,item.name)">
                    <div class="describe-div">{{ item.name }}</div>
                    <img :src="item.url" alt="alt">
                  </div>
                </div>

                <div class="rig-box" v-if="active == 1">
                  <p class="rig-title">{{ $t("choose.resource") }}</p>
                  <p class="rig-content">{{ $t("choose.character") }}</p>
                  <p class="rig-title">{{ $t("choose.scope") }}</p>
                  <p class="rig-content">{{ $t("choose.location") }}</p></div>
              </div>
            </div>
          </div>

        </van-tab>
      </van-tabs>
      <div style="height: 200px"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xuanfeiguanggao: '',
      active: 0,
      datalist: [],
      addlist: [
        this.$t("choose.city"),
        this.$t("choose.price"),
      ],
      videoSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      baseInfo: []
    };
  },
  methods: {
    getAddress() {
      this.$http({
        method: 'get',
        url: 'address_list'
      }).then(res => {
        this.datalist = res.data;
      });
    },
    profile(id, n) {

      /*this.$toast(this.$t("choose_msg"));
      return false;*/
      this.$router.push({path: '/profile?id=' + id + '&name=' + n});
    },
    /*profile(id,n) {

      this.$toast(this.$t("msg.余额不足，请联系客服充值！"));
      return false;
      //this.$router.push({path: '/list?id=' + id+'&name='+n});
    },*/
    OnChange() {
      this.videolist = [];
      this.number = 0;
      this.page = 0;
      this.count = 0;
      //this.getVideoList();//获取视频列表
    },

    itemChange() {
      this.active = this.$refs.swiper.swiper.activeIndex
      //this.OnChange()
    },
    /* getVideoList() {
       this.$http({
         method: 'get',
         url: 'xuanfeilist',
         data: {id: this.active}
       }).then(res => {
         this.datalist = res.data;
       });
     },*/

    getChooseItem() {
      this.$http({
        method: 'get',
        url: 'base_choose'
      }).then(res => {
        if (res.code == 200) {
          this.xuanfeiguanggao = res.data.xuanfeiguanggao;
        }
      })
    },

    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {

        this.baseInfo = res.data;
      })
    }
  },
  created() {
    // this.getChooseItem();
    this.getAddress();
    this.OnChange();
    this.getBaseInfo();
  }
};
</script>

<style lang="less" scoped>

</style>
